import { createEntityFilterConfig } from '../../factories/create-entity-filter-config';
import leadStatusApi from '@src/features/leads/services/lead-status-api';
import { STATIC_FILTER_ENTITY_TYPES } from '@shared/features/views/components/entities-filters/config';
import { LeadStatusFilterOptionItem } from './filter-option-item';
import { FILTER_COLOR } from '../filter-colors';

export const leadStatusFilterConfig = createEntityFilterConfig({
  facetName: 'status',
  fetchInfiniteData: leadStatusApi.useFetchInfinite,
  entityType: STATIC_FILTER_ENTITY_TYPES.leadStatus,
  getValue: (item) => String(item.id),
  renderItem: LeadStatusFilterOptionItem,
  color: FILTER_COLOR.green,
});
